import { render, staticRenderFns } from "./OnlineCoursesList.vue?vue&type=template&id=515eda40&scoped=true"
import script from "./OnlineCoursesList.vue?vue&type=script&lang=ts"
export * from "./OnlineCoursesList.vue?vue&type=script&lang=ts"
import style0 from "./OnlineCoursesList.vue?vue&type=style&index=0&id=515eda40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515eda40",
  null
  
)

export default component.exports